export default {


    // Colors
    Colors: {
        Primary: {
            main: '#44be9b',
        },
        Secondary: {
            main: '#284358',
        },
        Gradient: ['#44be9b', '#41A1DE'],
        Grey1: '#707070',
        Error: '#EA4F4F',
        Success: '#3BB558',

        Text: {
            primary: '#343434',
            secondary: '#707070',
            title: '#1F1F1F'
        },

        White: '#FFF'
    }

}